import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

import ProductsList from "../LicenseManagement/ProductsList";

const StudentLicenseManagemenModal = ({
  preselectedStudent,
  className,
  toggle,
  isOpen,
}) => {
  const toggleModal = () => {
    toggle();
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}></ModalHeader>
      <ModalBody>
        <ProductsList
          preselectedStudent={preselectedStudent}
          className={className}
          inModal={true}
        />
      </ModalBody>
    </Modal>
  );
};

export default StudentLicenseManagemenModal;
